export enum FormType {
  input = 'Input',
  dropdown = 'Dropdown'
}
